const documentReviewReviewerKPIs = [
    {
        "uuid": "1",
        "appType": "初次申請",
        "reviewer": "覆核員A",
        "appQuantity": 2,
        "sentTimes": 2,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "2",
        "appType": "增列評鑑場所",
        "reviewer": "覆核員A",
        "appQuantity": 12,
        "sentTimes": 24,
        "timeComplianceRate": 83,
    },
    {
        "uuid": "3",
        "appType": "展延",
        "reviewer": "覆核員A",
        "appQuantity": 20,
        "sentTimes": 30,
        "timeComplianceRate": 90,
    },
    {
        "uuid": "5",
        "appType": "初次申請",
        "reviewer": "覆核員B",
        "appQuantity": 1,
        "sentTimes": 1,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "6",
        "appType": "增列評鑑場品",
        "reviewer": "覆核員B",
        "appQuantity": 1,
        "sentTimes": 1,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "7",
        "appType": "展延",
        "reviewer": "覆核員B",
        "appQuantity": 10,
        "sentTimes": 10,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "8",
        "appType": "異動",
        "reviewer": "覆核員B",
        "appQuantity": 2,
        "sentTimes": 4,
        "timeComplianceRate": 100,
    },
    {
        "uuid": "9",
        "appType": "標示審查",
        "reviewer": "覆核員B",
        "appQuantity": 2,
        "sentTimes": 2,
        "timeComplianceRate": 100,
    },
]

export default documentReviewReviewerKPIs;